export class QueryModel {
  currentPage: number = 1;
  pageSize: number = 10;
  sort: string = 'Id';
  sortDirection: string = 'des';
  searchTerm: string = '';
  modelName: string = '';
}

export interface IQueryModel {
  currentPage: number;
  pageSize: number;
  totalitems?: number;
  startFrom?: string;
  ServiceTypeId?: number;
  ServiceStatusId?: number;
  sort: string;
  sortDirection: string;
  searchTerm?: string;
}
